import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';

import {GrowlService} from '@app/core';
import {AccountSetting} from '@app/shared/classes/account-setting';
import {LedgerAccountInfo} from '@app/shared/classes/ledger-account-info';

import {AccountService} from '../../services/account.service';
import {CommonTransformationService} from '@app/shared/services/common-transformation.service';
import {OrgAccountSettingService} from './org-account-setting-data.service';
import {AccountSettingService} from "@app/solution-manager/system/account-setting/account-setting-data.service";
import {classToClass, plainToClass} from "class-transformer";
import {PrimeNgConfig, TableColumn, TableFormat} from '@app/shared';

@Component({
  selector: 'app-org-account-setting',
  templateUrl: './org-account-setting.component.html',
  styleUrls: ['./org-account-setting.component.css'],
  providers: [OrgAccountSettingService, AccountSettingService]
})

export class OrgAccountSettingComponent implements OnInit, AfterViewInit {

  @Input() transaction: string;
  @Input() refId: number;
  @Output() handlerSave: EventEmitter<any> = new EventEmitter();  // emits back to trading partner parent to trigger Update

  PrimeNgConfig = PrimeNgConfig;
  tableColumns: TableColumn[];                          // table headers/fields
  displayAccountDialog: boolean = false;                   // dialog for account selection

  ledgerAccountsDropdown: SelectItem[];                 // has list of all expense type accounts from backend
  selectedAccountSetting: AccountSetting = new AccountSetting();        // object modeled in account dialog
  accountSettings: AccountSetting[];

  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

  constructor(private confirmationService: ConfirmationService, private accountDataService: AccountService, private growl: GrowlService, private orgAccountSettingService: OrgAccountSettingService,
              private commonTransService: CommonTransformationService) {
  }


  ngOnInit() {
    this.getAccountSettings();
    this.getLedgerAccountsDropdown();
  }

  ngAfterViewInit() {
    this.initTableColumns();
  }

  onChangeSelectedAccount(event: SelectItem<LedgerAccountInfo>): void {
    if (event.value) {
      this.selectedAccountSetting.ledgerAccountId = event.value.ledgerAccountId;
    }
  }

  /**
   * @desc edit the existing expense account
   * @param row account line item
   */
  onClickEditAccount(row: AccountSetting): void {
    if (row.refId) {
      this.selectedAccountSetting = classToClass(row);
      this.selectedAccountSetting.refId = this.refId;
    } else {
      let newAccountSetting = new AccountSetting();
      newAccountSetting = classToClass(row);
      // this.selectedAccountSetting = classToClass(row);
      newAccountSetting.id = null;
      newAccountSetting.version = 0;
      newAccountSetting.refId = this.refId;
      newAccountSetting.inherited = true;
      this.selectedAccountSetting = newAccountSetting;
    }
    this.displayAccountDialog = true;
  }

  onClickUpdateAccount(accountSetting: AccountSetting): void {
    if (accountSetting.id) {
      this.orgAccountSettingService.updateAccountSetting(this.selectedAccountSetting).subscribe(res => {
        this.displayAccountDialog = false;
        this.getAccountSettings();
      });
    } else {
      this.orgAccountSettingService.saveAccountSetting(this.selectedAccountSetting).subscribe(res => {
        this.displayAccountDialog = false;
        this.getAccountSettings();
      });
    }
  }

  /**
   * @desc closes the dialog
   */
  onCloseDialog(): void {
    this.displayAccountDialog = false;
  }

  /**
   * @desc this method sets up the Columns for the p-table
   */
  private initTableColumns(): void {
    this.tableColumns = [
      {field: 'lookupType', header: 'Lookup Type', format: TableFormat.TitleCase},
      {field: 'transaction', header: 'Transaction', format: TableFormat.TitleCase},
      {field: 'ledgerAccountInfo', subfield: 'accountNumber', header: 'Number'},
      {field: 'ledgerAccountInfo', subfield: 'accountName', header: 'Name'},
      {field: 'ledgerAccountInfo', subfield: 'accountDescription', header: 'Description'},
      {field: 'accountSettingsType', header: 'Account Setting Type', format: TableFormat.TitleCase},
      {field: 'action', header: 'Action', template: this.actionTemplate}
    ];
  }

  private getAccountSettings(): void {
    this.orgAccountSettingService.getDefaultOrgAccountSetting(this.transaction, this.refId).subscribe(res => {
      this.accountSettings = plainToClass(AccountSetting, res);
    });
  }

  private getLedgerAccountsDropdown(): void {
    this.accountDataService.searchLedgerAccountInfo(null, null, null, null, true, true, true).subscribe(res => {
      this.ledgerAccountsDropdown = this.commonTransService.convertToDropDown('accountName', res.list);
    });
  }
}
